/**
 * Copyright (c) 2020, Trend Micro, Inc.
 * All rights reserved.
 */

window.c1cSupported = false;
const scriptTag1 = document.createElement('script');
scriptTag1.id = 'err-test';
scriptTag1.textContent =
  "try { import('nothing').then((module) => {}).catch(() => {}); } catch (e) {} window.c1cSupported = true;";
document.head.appendChild(scriptTag1);

const scriptTag2 = document.createElement('script');
scriptTag2.id = 'err-handle';
scriptTag2.textContent = `if(window.c1cSupported) {(document.getElementById('err-test')).remove();(document.getElementById('err-handle')).remove();} else { window.location.href = '/static-${BUILD_TIMESTAMP}/unsupported-browser';}`;
document.head.appendChild(scriptTag2);
